import { useRef, useState } from 'react'
import SymbolIcon from './SymbolIcon'
import InputLeadingIcon from './InputLeadingIcon'
import './PasswordInput.css'

function PasswordInput({ id, value, onChange, disabled = false, invalid = false, autoComplete, leadingIcon, ...inputProps }) {
  const [isVisible, setIsVisible] = useState(false)
  const inputRef = useRef(null)
  const visibilityLabel = isVisible ? 'Passwort verbergen' : 'Passwort anzeigen'

  return (
    <div className={`password-input-wrap${invalid ? ' is-invalid' : ''}${leadingIcon ? ' has-leading-icon' : ''}`}>
      {leadingIcon && <InputLeadingIcon icon={leadingIcon} />}
      <input
        {...inputProps}
        ref={inputRef}
        id={id}
        type={isVisible ? 'text' : 'password'}
        value={value}
        onChange={onChange}
        disabled={disabled}
        aria-invalid={invalid || undefined}
        autoComplete={autoComplete}
      />
      <button
        className="password-visibility-toggle"
        type="button"
        onPointerDown={(event) => {
          if (document.activeElement === inputRef.current) event.preventDefault()
        }}
        onClick={() => setIsVisible((prev) => !prev)}
        disabled={disabled}
        aria-label={visibilityLabel}
        title={visibilityLabel}
      >
        <SymbolIcon icon={isVisible ? 'visibility_off' : 'visibility'} />
      </button>
    </div>
  )
}

export default PasswordInput
